import { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);
const LS_KEY = "ambdrop_cart_v1";

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(LS_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(LS_KEY, JSON.stringify(items));
  }, [items]);

  const parsePrice = (s) => Number(String(s).replace(/,/g, "")) || 0;

  const add = useCallback((product, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.product_id === product.id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: next[idx].qty + qty };
        return next;
      }
      return [
        ...prev,
        {
          product_id: product.id,
          name: product.name,
          price_inr: product.price_inr,
          image_url: product.image_url,
          qty,
        },
      ];
    });
  }, []);

  const remove = useCallback((product_id) => {
    setItems((prev) => prev.filter((i) => i.product_id !== product_id));
  }, []);

  const setQty = useCallback((product_id, qty) => {
    setItems((prev) =>
      prev
        .map((i) => (i.product_id === product_id ? { ...i, qty } : i))
        .filter((i) => i.qty > 0)
    );
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((s, i) => s + i.qty, 0);
  const subtotal = items.reduce((s, i) => s + parsePrice(i.price_inr) * i.qty, 0);
  const formatted = subtotal.toLocaleString("en-IN");

  const value = {
    items,
    count,
    subtotal,
    subtotalFormatted: formatted,
    open,
    setOpen,
    add,
    remove,
    setQty,
    clear,
  };
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
};

export const useCart = () => {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart outside CartProvider");
  return ctx;
};
